import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 1,
  style: {"font-size":"14px"}
}

import { useSlots } from 'vue';
interface Props {
  only: Object | Array<any> | string | number | boolean;
}

interface Emits {
  (e: 'rightClick', payload: Props['only']): void;
  (e: 'leftClick', payload: Props['only']): void;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  width: {
    type: String,
    default: '100%', // 默认宽度为 100%
  },
  height: {
    type: String,
    default: '35px', // 默认高度为 30px
  },
  leftWidth: {
    type: String,
    default: '30%',
  },
  rightWidth: {
    type: String,
    default: '50%',
  },
  rightText: {
    type: String,
    default: '默认按钮',
  },
  leftText: {
    type: String,
    default: '默认按钮',
  },
  // 如果在循环中，点击事件时需要获取当前点击的项，且 该值可能是任何类型
  only: {
    type: [Object, Array, String, Number, Boolean],
  },
  rightDisabled: {
    type: Boolean,
    default: false,
  },
  // 新增：是否显示左侧按钮（暂存按钮）
  showLeftButton: {
    type: Boolean,
    default: true, // 默认显示左侧按钮
  },
},
  emits: ["rightClick", "leftClick"],
  setup(__props, { emit: __emit }) {

const slots = useSlots();

const props = __props;

// 事件
const emits = __emit;

const _rightClick = () => {
  if (props.rightDisabled) return;
  emits('rightClick', props.only as Props);
};
const _leftClick = () => {
  emits('leftClick', props.only as Props);
};

return (_ctx: any,_cache: any) => {
  const _component_taro_view = _resolveComponent("taro-view")!
  const _component_taro_button = _resolveComponent("taro-button")!

  return (_openBlock(), _createBlock(_component_taro_view, {
    class: "button",
    style: _normalizeStyle({ width: __props.width, height: __props.height })
  }, {
    default: _withCtx(() => [
      (__props.showLeftButton)
        ? (_openBlock(), _createBlock(_component_taro_view, {
            key: 0,
            class: "button-left",
            style: _normalizeStyle({ width: __props.leftWidth, height: __props.height }),
            onTap: _leftClick
          }, {
            default: _withCtx(() => [
              (_unref(slots).left)
                ? _renderSlot(_ctx.$slots, "left", { key: 0 }, () => [
                    _cache[0] || (_cache[0] = _createTextVNode("默认左侧内容"))
                  ], true)
                : (__props.leftText)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.leftText), 1))
                  : _createCommentVNode("", true)
            ]),
            _: 3
          }, 8, ["style"]))
        : _createCommentVNode("", true),
      _createVNode(_component_taro_button, {
        class: _normalizeClass(["button-right", {
        'opacity-50 cursor-not-allowed bg-gray-400': __props.rightDisabled,
        'button-right-only': !__props.showLeftButton,
      }]),
        disabled: __props.rightDisabled,
        style: _normalizeStyle({
        height: __props.height,
      }),
        onTap: _rightClick
      }, {
        default: _withCtx(() => [
          (_unref(slots).right)
            ? _renderSlot(_ctx.$slots, "right", { key: 0 }, () => [
                _cache[1] || (_cache[1] = _createTextVNode("默认按钮"))
              ], true)
            : (__props.rightText)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.rightText), 1))
              : _createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["class", "disabled", "style"])
    ]),
    _: 3
  }, 8, ["style"]))
}
}

})